import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Stack from "@vapor/react-material/Stack";
import VaporPage from "@vapor/react-custom/VaporPage";
import { LeadManagement } from "./LeadManagement.tsx";
import { Button } from "@vapor/react-material";
import { jwtDecode } from "jwt-decode";

const TableView = () => {
  const navigate = useNavigate();

  interface DecodedType {
    role: string;
  }
  const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InRzZGlnaXRhbGFneW8rMTZAZ21haWwuY29tIiwiZ2l2ZW5fbmFtZSI6IkdpYW5uaSIsInJvbGUiOiJBZG1pbiIsImV4cCI6MTcwMDgzNDQwMCwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDozMDAwLyIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6MzAwMC8ifQ.nVIy5PTdZ-Ehtf2_WsG4_0XsVa-nItr0hRTQf_4FqrY";
  const decoded: DecodedType = jwtDecode(token);
  const userRole: string = decoded.role;

  console.log("User role:", userRole);
  console.log("User role:", typeof decoded.role);

  return (
    <VaporPage title="Invoices">
      <VaporPage.Section>
        <Stack
          padding="1rem"
          marginBottom="1rem"
          spacing="3"
          direction="row"
          justifyContent="flex-end"
        >
          {userRole === "Admin" && (
            <Button
              variant="contained"
              onClick={() => navigate("/leadManagement/new-invoice")}
            >
              New Invoice
            </Button>
          )}
        </Stack>
        <LeadManagement />
        
       
      </VaporPage.Section>
    </VaporPage>
  );
};

export default TableView;
